import React, { Component } from "react";

export default class KirokuCardBodyWeb extends Component {
    render() {
        return (
            <div className='card-body' {...this.props}>
                {this.props.children}
            </div>
        )
    }
}